module.exports = __webpack_public_path__ + "static/thinking-in-bets-8dd95b644ae190362b2e9908eb4c00ec.jpg";